import styles from "../../styles/button.module.scss";

import classNames from "classnames/bind";

import { isMobile } from "react-device-detect";

import { Icon } from "../components/core/Icon";

export const Button = ({
  design = "default",
  type = "button",
  children,
  disabled,
  onClick,
  className = "",
  loading,
  add,
  title,
  text,
  dot,
  tabIndex,
}) => {
  const cx = classNames.bind(styles);

  const handleClick = (e) => {
    e.stopPropagation();
    onClick && onClick(e);
  };

  return (
    <button
      title={title}
      type={type}
      onClick={handleClick}
      className={cx({
        button: true,
        loading: loading,
        [design]: true,
        [className]: className,
        add: add && isMobile,
      })}
      disabled={disabled}
      tabIndex={tabIndex}
    >
      {isMobile && add ? (
        <Icon name="plus" size="xl" />
      ) : !loading ? (
        text || children
      ) : (
        ""
      )}

      {loading && (
        <div className={styles.loading}>
          <span className={styles.loader}></span>
        </div>
      )}
      {dot && <div className={styles.dot} />}
    </button>
  );
};
